import $ from 'jquery';

class ConferenceSpecialEvents {
	constructor(node) {
		this.node = node;

		let containerEl = this.node.querySelector('.js-special-events-mixitup');

		let mixer = mixitup(containerEl, {
			animation: {
				animateResizeTargets: true
			}
		});

	}
}

export default ConferenceSpecialEvents;
